var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-field-select',{attrs:{"label":_vm.label,"value":_vm.value,"validation-errors":_vm.validationErrors,"help-text":_vm.helpText},on:{"change":_vm.handleInput}},_vm._l((_vm.ENUMS.TemperatureEnum),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v(_vm._s(option.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }